import VendorAllocatedOrder from './VendorAllocatedOrder.vue';

if (document.querySelector('#vendors-allocated-order')) {
  const aoData = document.querySelector('#vendors-allocated-order').dataset;

  var app = new Vue({
    el: '#vendors-allocated-order',
    template: '<VendorAllocatedOrder :order="this.order"/>',
    components: {
      VendorAllocatedOrder
    },
    data(){
      return {
        order: JSON.parse(aoData.order)
      };
    }
  });
}